(function () {
  if (window.VSCartMutation) return;

  var owner = null;
  var controlSelector = [
    '[name="checkout"]',
    '[data-vsp-add]',
    '[data-add-button]',
    '[data-mobile-add]',
    '[data-variant-select]',
    '[data-max-toggle]',
    '[data-vsj-buy]',
    '[data-vsj-mobile-submit]',
    '[data-vsc-remove]',
    '[data-vsc-quantity-change]',
    '[data-vsc-max-toggle]',
    '[data-vsc-add]',
    '[data-vs-cart-max-toggle]',
    '[data-vs-bundle-add]',
    'button[name="add"]'
  ].join(',');

  function setControlsLocked(locked) {
    document.querySelectorAll(controlSelector).forEach(function (control) {
      if (!('disabled' in control)) return;

      if (locked) {
        control.dataset.vsCartWasDisabled = control.disabled ? 'true' : 'false';
        control.disabled = true;
        return;
      }

      if (control.dataset.vsCartWasDisabled === 'false') control.disabled = false;
      delete control.dataset.vsCartWasDisabled;
    });
  }

  function announceState(busy, source) {
    window.dispatchEvent(new CustomEvent('vs:cart-mutation-state', {
      detail: {
        busy: busy,
        source: source || 'unknown'
      }
    }));
  }

  function reset(source) {
    var previousOwner = owner;
    owner = null;
    window.__vsCartMutationInFlight = false;
    document.documentElement.removeAttribute('data-vs-cart-busy');
    setControlsLocked(false);
    announceState(false, source || previousOwner || 'unknown');
    return Boolean(previousOwner);
  }

  function request(input, init, timeoutMs) {
    var options = Object.assign({}, init || {});
    var duration = Number(timeoutMs || 15000);

    if (!window.AbortController || !Number.isFinite(duration) || duration <= 0) {
      return window.fetch(input, options);
    }

    var controller = new AbortController();
    var externalSignal = options.signal;
    var timedOut = false;
    var forwardAbort = function () { controller.abort(); };

    if (externalSignal) {
      if (externalSignal.aborted) controller.abort();
      else externalSignal.addEventListener('abort', forwardAbort, { once: true });
    }

    options.signal = controller.signal;
    var timeoutId = window.setTimeout(function () {
      timedOut = true;
      controller.abort();
    }, duration);

    return window.fetch(input, options)
      .then(function (response) {
        // Fetch resolves on headers, not on a complete cart JSON/section payload.
        // Drain a clone under the same deadline, retaining the original Response
        // (including 422/status/headers) and its unread body for existing callers.
        // This helper is scoped to finite cart/section responses, not streams.
        if (!response.body) return response;
        return response.clone().arrayBuffer().then(function () { return response; });
      })
      .catch(function (error) {
        if (timedOut) {
          var timeoutError = new Error('Przekroczono czas oczekiwania na odpowiedź sklepu. Spróbuj ponownie.');
          timeoutError.name = 'TimeoutError';
          throw timeoutError;
        }
        throw error;
      })
      .finally(function () {
        window.clearTimeout(timeoutId);
        if (externalSignal) externalSignal.removeEventListener('abort', forwardAbort);
      });
  }

  window.VSCartMutation = {
    begin: function (source) {
      if (owner) return false;
      owner = source || 'unknown';
      window.__vsCartMutationInFlight = true;
      document.documentElement.setAttribute('data-vs-cart-busy', 'true');
      setControlsLocked(true);
      announceState(true, owner);
      return true;
    },

    end: function (source) {
      if (!owner || (source && source !== owner)) return false;
      reset(source || owner);
      return true;
    },

    isBusy: function () {
      return Boolean(owner);
    },

    request: request
  };

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    reset('history-restore');
  });
})();
